import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'gold' | 'track' | 'outline';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'gold',
  title,
  lead,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl';
  return <div className={`${alignment} ${className}`} data-id="element-176" data-mp="gjgj8u6d7cmj">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-177" data-mp="giwyz6t8sc5c">{eyebrow}</Pill> : null}
      <h2 className={`font-serif text-[2rem] font-bold leading-[1.1] text-stone-100 sm:text-4xl lg:text-[2.75rem] ${eyebrow ? 'mt-5' : ''}`} data-id="element-178" data-mp="1v3ou1mxe1u5">
        {title}
      </h2>
      {lead ? <p className={`mt-4 font-sans text-base leading-relaxed text-stone-400 ${align === 'center' ? 'mx-auto max-w-prose' : 'max-w-prose'}`} data-id="element-179" data-mp="uj7u4m1l4cwb">
          {lead}
        </p> : null}
    </div>;
}